import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

const filters: App.OfferListFilters = {
  cruiseLines: [
    'AZA', // Azamara
    'SRX', // Silversea
    'RDC', // Regent Seven Seas
    'CRS', // Crystal
    'SBN', // Seabourn
    'EXJ', // Explora Journeys
  ],
}

function CruisePageLuxuryPremiumCruisesCarousel() {
  const intl = useIntl()
  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  const viewAllLabel = intl.formatMessage({
    id: 'QNGIURmgk2A7mMa-7Rup',
    defaultMessage: 'View all',
    description: 'Button text to view all luxury cruise offers in the cruise section',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="XNHXIUts9EOkzbmVDNRi"
            defaultMessage="Luxury <i>cruises</i>"
            description="Section heading for luxury and premium cruise offers"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>

        <TextButton
          to={`/search/cruises?${qs.stringify(filters, { arrayFormat: 'repeat' })}`}
          kind="tertiary"
          variant="dark"
        >
          {viewAllLabel}
        </TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageLuxuryPremiumCruisesCarousel
